// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-modal-content{
    background-color: #D9D9D9 !important;
}
.ant-input-wrapper .ant-input-group{
    height: 50px;
}
.ant-input-group .ant-input {
    height: 50px;
}
.ant-input-group .ant-input {
    height: 50px;
} 

:where(.css-dev-only-do-not-override-1kf000u).ant-input-group .ant-input {
    height: 50px;
}

.ant-input-search .ant-input-search-button {
    height: 50px;
}
.ant-input-search.ant-input-search-with-button{
height: 50px;
}
.ant-btn-variant-solid{
background-color: #f7941d;
}
.ant-btn-variant-solid:hover{
    background-color: #f7941d;
    }

    .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover{
        background-color: #f7941d;
    }
    .products-card {
        background: #262626; /* Remove quotes around color */
        border-radius: 12px; /* Corrected border-radius property */
        border: 1px solid #d9d9d91f;
        padding: 30px 30px 10px 30px;
        height: auto; /* Added px unit */
        width: 35%; /* Correct syntax for width */
        display: flex;
        flex-direction: column; /* Corrected property name */
        justify-content: flex-start;
        align-items: flex-start;
        gap: 10px; /* Added px unit */
        margin-bottom: 20px;
        margin-right: 20px; /* Added px unit */
    }
    
@media only screen and (max-width: 1000px) {
    .products-card {
        width: 90%;
        height: auto;
        overflow: auto;
    }
}
.products-card .desc{
    padding-right: 10px;
    scrollbar-width: thin;  
}

.products-card {
    box-shadow: 0 0 15px #bebdbd1f;
}

.products-card:hover {
    transform: scale(1.01);
    box-shadow: 0 0 15px #d9d9d91f;
}
`, "",{"version":3,"sources":["webpack://./src/pages/products/products.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;AACA;AACA,YAAY;AACZ;AACA;AACA,yBAAyB;AACzB;AACA;IACI,yBAAyB;IACzB;;IAEA;QACI,yBAAyB;IAC7B;IACA;QACI,mBAAmB,EAAE,+BAA+B;QACpD,mBAAmB,EAAE,qCAAqC;QAC1D,2BAA2B;QAC3B,4BAA4B;QAC5B,YAAY,EAAE,kBAAkB;QAChC,UAAU,EAAE,6BAA6B;QACzC,aAAa;QACb,sBAAsB,EAAE,4BAA4B;QACpD,2BAA2B;QAC3B,uBAAuB;QACvB,SAAS,EAAE,kBAAkB;QAC7B,mBAAmB;QACnB,kBAAkB,EAAE,kBAAkB;IAC1C;;AAEJ;IACI;QACI,UAAU;QACV,YAAY;QACZ,cAAc;IAClB;AACJ;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC","sourcesContent":[".ant-modal-content{\r\n    background-color: #D9D9D9 !important;\r\n}\r\n.ant-input-wrapper .ant-input-group{\r\n    height: 50px;\r\n}\r\n.ant-input-group .ant-input {\r\n    height: 50px;\r\n}\r\n.ant-input-group .ant-input {\r\n    height: 50px;\r\n} \r\n\r\n:where(.css-dev-only-do-not-override-1kf000u).ant-input-group .ant-input {\r\n    height: 50px;\r\n}\r\n\r\n.ant-input-search .ant-input-search-button {\r\n    height: 50px;\r\n}\r\n.ant-input-search.ant-input-search-with-button{\r\nheight: 50px;\r\n}\r\n.ant-btn-variant-solid{\r\nbackground-color: #f7941d;\r\n}\r\n.ant-btn-variant-solid:hover{\r\n    background-color: #f7941d;\r\n    }\r\n\r\n    .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover{\r\n        background-color: #f7941d;\r\n    }\r\n    .products-card {\r\n        background: #262626; /* Remove quotes around color */\r\n        border-radius: 12px; /* Corrected border-radius property */\r\n        border: 1px solid #d9d9d91f;\r\n        padding: 30px 30px 10px 30px;\r\n        height: auto; /* Added px unit */\r\n        width: 35%; /* Correct syntax for width */\r\n        display: flex;\r\n        flex-direction: column; /* Corrected property name */\r\n        justify-content: flex-start;\r\n        align-items: flex-start;\r\n        gap: 10px; /* Added px unit */\r\n        margin-bottom: 20px;\r\n        margin-right: 20px; /* Added px unit */\r\n    }\r\n    \r\n@media only screen and (max-width: 1000px) {\r\n    .products-card {\r\n        width: 90%;\r\n        height: auto;\r\n        overflow: auto;\r\n    }\r\n}\r\n.products-card .desc{\r\n    padding-right: 10px;\r\n    scrollbar-width: thin;  \r\n}\r\n\r\n.products-card {\r\n    box-shadow: 0 0 15px #bebdbd1f;\r\n}\r\n\r\n.products-card:hover {\r\n    transform: scale(1.01);\r\n    box-shadow: 0 0 15px #d9d9d91f;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
